import { Badge, Button, ActionBar } from "frontend-kit/components/index.js";
import { SECURITY_GUIDE } from "./guide-copy.js";
import { privacyPolicyLink } from "./legal-copy.js";
import { settingsHash } from "./settings-sections.js";

/**
 * Security tab body: guide sections + CTA to Account for key actions.
 * @param {{ onOpenAccount?: () => void }} [opts]
 * @returns {HTMLElement}
 */
export function renderSettingsSecurityPanel({ onOpenAccount } = {}) {
  const root = document.createElement("div");
  root.className = "settings-security-panel";

  for (const section of SECURITY_GUIDE) {
    const block = document.createElement("section");
    block.className = "settings-section dt-card settings-guide-block";
    block.dataset.guideId = section.id;

    const head = document.createElement("div");
    head.className = "settings-guide-head";
    const h3 = document.createElement("h3");
    h3.textContent = section.title;
    head.append(h3);
    if (section.planned) {
      head.append(Badge({ variant: "pending", label: "Coming" }));
    }
    block.append(head);

    const p = document.createElement("p");
    p.className = "hint";
    p.textContent = section.body;
    block.append(p);
    root.append(block);
  }

  const actions = document.createElement("div");
  actions.className = "settings-security-actions";
  actions.append(
    ActionBar([
      Button({
        label: "Manage trading key on Account",
        variant: "primary",
        onClick: () => {
          if (onOpenAccount) onOpenAccount();
          else location.hash = settingsHash("account");
        },
      }),
      privacyPolicyLink(),
    ])
  );
  root.append(actions);

  return root;
}
